export default __webpack_public_path__ + "b382155ac4442484694fa63ec651d452.png";